'use strict';

var _ = require('lodash');
var SearchCriteriaKeyboardSupportService = function SearchCriteriaKeyboardSupportService(hotkeys) {
  function triggerActionAndStopEvent(action, event) {
    action();
    event.stopPropagation();
    event.preventDefault();
  }
  function addHotKeys(scope) {
    hotkeys.add({
      combo: 'alt+d',
      description: 'Add new criteria',
      callback: _.wrap(scope.addSearchCriteriaRule, triggerActionAndStopEvent)
    });
    hotkeys.add({
      combo: 'enter',
      description: 'Search',
      callback: _.wrap(scope.onSearchButtonClick, triggerActionAndStopEvent)
    });
    hotkeys.add({
      combo: 'ctrl+l',
      description: 'Clear',
      callback: _.wrap(scope.onClearButtonClick, triggerActionAndStopEvent)
    });
    hotkeys.add({
      combo: 'ctrl+s',
      description: 'Save',
      callback: _.wrap(scope.onSaveButtonClick, triggerActionAndStopEvent)
    });
    hotkeys.add({
      combo: 'esc',
      description: 'Cancel',
      callback: _.wrap(scope.onCancelButtonClick, triggerActionAndStopEvent)
    });
  }
  function removeHotKeys() {
    hotkeys.del('alt+d');
    hotkeys.del('enter');
    hotkeys.del('ctrl+l');
    hotkeys.del('ctrl+s');
    hotkeys.del('esc');
  }
  return {
    addHotKeys: addHotKeys,
    removeHotKeys: removeHotKeys
  };
};
SearchCriteriaKeyboardSupportService.$inject = ['hotkeys'];
module.exports = SearchCriteriaKeyboardSupportService;